import { useQuery } from '@tanstack/react-query';

import { callGetUserById } from '@app/client/resources/yat-pages/pages';

export const USER_YATS_QUERY_CACHE = 'USER_YATS_QUERY_CACHE';

type UseGetUserYatsProps = {
    userId?: string;
};

export const useGetUserYats = ({ userId }: UseGetUserYatsProps) => {
    return useQuery(
        [USER_YATS_QUERY_CACHE, userId],
        ({ signal }) => callGetUserById({ settings: { signal }, id: userId || '' }),
        { enabled: !!userId },
    );
};
